export default __webpack_public_path__ + "static/media/1572.56190c00.png";